import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BrandLogoDTO, BrandLogoShopDTO } from 'src/app/base/models/models.swagger.generated';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { BrandLogosService } from './brand-logos.service';
import { CommandClickEventArgs, CommandModel, RowSelectingEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { BrandLogosEditFormComponent } from './brand-logos-edit-form/brand-logos-edit-form.component';
import { BrandLogosDeleteDialogComponent } from './brand-logos-delete-dialog/brand-logos-delete-dialog.component';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-brand-logos',
    templateUrl: './brand-logos.component.html',
    styleUrls: ['./brand-logos.component.scss'],
    imports: [TitleBarComponent, GridModule, QueryBuilderModule, BrandLogosEditFormComponent, BrandLogosDeleteDialogComponent, TranslateModule]
})
export class BrandLogosComponent extends GridBaseComponent<any> implements OnInit{

  @ViewChild(BrandLogosEditFormComponent)
  public brandLogosEditFormComponent: BrandLogosEditFormComponent;

  @ViewChild(BrandLogosDeleteDialogComponent)
  public brandLogosDeleteDialogComponent: BrandLogosDeleteDialogComponent;

  public selectedBrandLogos: BrandLogoDTO[] = [];

  public isDeleteLogoBrandLogo: boolean = false;

  constructor(
    translateService: TranslateService,
    private brandLogosService: BrandLogosService,
    private spinnerService: SpinnerService
  ) {
    super(translateService, brandLogosService);
    this.gridCommands = [{
      type: 'Delete',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-trash-can e-icons'
      }
    } as CommandModel];
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.brandLogosService, this.spinnerService),
    });
  }

  public dataBound(): void {
    //Reset selection after filter and sorting changed
    this.grid.dataStateChange.subscribe(() => {
      this.grid.clearSelection();
    });
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === 'Delete'){
      var data = args.rowData as BrandLogoDTO;
      this.isDeleteLogoBrandLogo = !data.brandSub;
      this.brandLogosDeleteDialogComponent.showDeleteDialog(data.id);
    }
  }

  rowSelectedChanged() {
    this.selectedBrandLogos = this.grid.getSelectedRecords() as BrandLogoDTO[];
  }

  public assignLogos(): void {
    this.brandLogosEditFormComponent.assignLogos(this.selectedBrandLogos);
  }

  public filterRowSelection(event: RowSelectingEventArgs) {
    if (event.target.classList.contains('icon-trash-can')) {
      event.cancel = true;
    }
  }

  public getShopNames(shops: BrandLogoShopDTO[]): string {
    return shops?.map(shop => shop.shopId).join(', ');
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public onRowDataBound(args: any) {
    if (!args.data.fileLink) {
      var button = args.row.cells[args.row.cells.length - 1].getElementsByClassName('icon-trash-can');
        if (button)
          button[0].style.display = 'none';
    }
  }
}
